import { MDBInputGroup } from "mdb-react-ui-kit";
import { useContext } from "react";
import { TranslationContext } from "../../context/translations/translations-context";
import { useDarkMode } from "../assets/DarkModeContext";
import ReferentialSelect from "../assets/ReferentialSelect";
import CommonChipItem from "./CommonChipItem";

export default function LanguageSkillChipItem(
    {
        chip,
        handleRemove,
        handleChange,
        textBeforeMin,
        textBeforeMax,
        refLanguageLevels,
    }
) {
    const { displayLanguage, translations } = useContext( TranslationContext );
    const { isDarkMode } = useDarkMode();

    const filterDown = ( languageLevel ) => {
        return languageLevel.code <= (chip.maxLanguageLevel || 'NS');
    }

    const filterUp = ( languageLevel ) => {
        return languageLevel.code >= (chip.minLanguageLevel || 'A1');
    }

    return (
        <div className="row">
            <div className="col-4">
                <CommonChipItem chip={ chip } handleRemove={ handleRemove }/>
            </div>
            <div className="col-3">
                <MDBInputGroup className='mb-3' noBorder textBefore={ textBeforeMin }>
                    <ReferentialSelect
                        // name={ `min-education-level-chip[${ index }]` }
                        // elementId={ `min-education-level-chip[${ index }]` }
                        firstOption={ translations.advancedSearch.filterBy }
                        handleChange={ ( e ) => handleChange( chip, 'minLanguageLevel', e.target.value ) }
                        referential={ refLanguageLevels.filter( filterDown ) }
                        displayLanguage={ displayLanguage }
                        selectedItem={ chip.minLanguageLevel }
                        className={ `form-control ${ isDarkMode ? "text-white" : "text-muted" }` }
                        style={ { backgroundColor: 'transparent' } }
                    />
                </MDBInputGroup>
            </div>
            <div className="col-3">
                <MDBInputGroup className='mb-3' noBorder textBefore={ textBeforeMax }>
                    <ReferentialSelect
                        // name={ `max-education-level-chip[${ index }]` }
                        // elementId={ `max-education-level-chip[${ index }]` }
                        firstOption={ translations.advancedSearch.filterBy }
                        handleChange={ ( e ) => handleChange( chip, 'maxLanguageLevel', e.target.value ) }
                        referential={ refLanguageLevels.filter( filterUp ) }
                        displayLanguage={ displayLanguage }
                        selectedItem={ chip.maxLanguageLevel }
                        className={ `form-control ${ isDarkMode ? "text-white" : "text-muted" }` }
                        style={ { backgroundColor: 'transparent' } }
                    />
                </MDBInputGroup>
            </div>
        </div>
    );
}